import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../../course/components/sectionTitle';
import Quiz from '../../components/quiz';
import Conversation from './conversation';
import Component003 from './component003';
import Animation011 from './animation011';
import Animation028 from './animation028';
import Animation047 from './animation047';
import Component002 from './component002';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation011,
  Animation028,
  Animation047,
  Component002,
  Component003,
};

export default Components;
